export default "__VITE_ASSET__uvxXGVsF__"